import Vue from 'vue';
import deepEql from 'deep-eql';
import cloneDeep from 'clone-deep';

export const Differ = {
    state: {
        changedFields: {},
        invalidFields: {},
        createdModules: {},
        createdListItems: {},
        createdPages: {}
    },
    mutations: {
        addDiffer(state, { store, payload }) {
            if (
                !Object.values(state[store]).some((i) => {
                    if (store === 'changedFields') {
                        return i.route === payload.route && i.source === payload.source;
                    } else {
                        return deepEql(i, payload);
                    }
                })
            ) {
                let key = 0;
                while (state[store][key] !== undefined) {
                    key++;
                }
                Vue.set(state[store], key, cloneDeep(payload));
            }
        },
        deleteDiffer(state, { store, payload }) {
            Object.keys(state[store]).forEach((key) => {
                if (deepEql(state[store][key], payload)) {
                    Vue.delete(state[store], key);
                }
            });
        },
        deleteDifferAll(state, { route }) {
            Object.keys(state).forEach((store) => {
                Object.keys(state[store]).forEach((key) => {
                    if (state[store][key].route === route) {
                        Vue.delete(state[store], key);
                    }
                });
            });
        }
    },
    getters: {
        differHasChangesInRoute(state) {
            return (route) => {
                return (
                    Object.values(state.changedFields).some((i) => i.route === route) ||
                    Object.values(state.createdModules).some((i) => i.route === route) ||
                    Object.values(state.createdListItems).some((i) => i.route === route)
                );
            };
        },
        differHasInvalidFieldsInRoute(state) {
            return (route) => {
                return Object.values(state.invalidFields).some((i) => i.route === route);
            };
        }
    },
    actions: {
        async addDifferChangedField(context, payload) {
            context.commit('addDiffer', { store: 'changedFields', payload: payload });
        },
        async addDifferInvalidField(context, payload) {
            context.commit('addDiffer', { store: 'invalidFields', payload: payload });
        },
        async addDifferCreatedModule(context, payload) {
            context.commit('addDiffer', { store: 'createdModules', payload: payload });
        },
        async addDifferCreatedListItem(context, payload) {
            context.commit('addDiffer', { store: 'createdListItems', payload: payload });
        },
        async deleteDifferInvalidField(context, payload) {
            context.commit('deleteDiffer', { store: 'invalidFields', payload: payload });
        },
        async forgetDifferInRoute(context, route) {
            context.commit('deleteDifferAll', { route: route });
        },
        async rollbackDifferInRoute(context, route) {
            // changed fields
            for (let changedFields__value of Object.values(context.state.changedFields)) {
                if (changedFields__value.route === route) {
                    await context.dispatch('setProp', {
                        source: changedFields__value.source,
                        value: changedFields__value.value
                    });
                }
            }
            // created modules
            for (let createdModules__value of Object.values(context.state.createdModules)) {
                if (createdModules__value.route === route) {
                    await context.dispatch('removeModule', {
                        id: createdModules__value.id,
                        confirm: false,
                        route: false,
                        save: false
                    });
                }
            }
            // created listitems
            for (let createdListItems__value of Object.values(context.state.createdListItems)) {
                if (createdListItems__value.route === route) {
                    await context.dispatch('removeListItem', {
                        id: createdListItems__value.id,
                        source: createdListItems__value.source,
                        confirm: false,
                        route: false,
                        save: false
                    });
                }
            }
            await context.dispatch('forgetDifferInRoute', route);
            await context.dispatch('saveAllData');
        }
    }
};
